import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isMobile from 'is-mobile';

const isTimeBlock = type => type === 'time';

const showTitle = (allDay, view) => {
  if (allDay && isMobile()) {
    switch (view) {
      case 'week':
      case 'day':
        return false;
      default:
        return true;
    }
  }
  return true;
};

const calendarEventClassNames = (variant, status, type, time, allDay, view) =>
  classNames(
    'rbc-event',
    'calendar__event',
    `calendar__event--${variant}`,
    `calendar__event--${variant}--${status}`,
    { [`calendar__event--${variant}--all-day`]: !showTitle(allDay, view) },
    {
      'calendar__event--all-day-block':
        !showTitle(allDay, view) && !isTimeBlock(type) && !time
    },
    !allDay && isTimeBlock(type)
      ? 'calendar__event--time-block'
      : 'calendar__event--date-block'
  );

const calendarEventStyles = (style, rtl, xOffset) =>
  style && {
    ...style,
    top: `${style.top}%`,
    height: `${style.height}%`,
    [rtl ? 'right' : 'left']: `${Math.max(0, xOffset)}%`,
    width: `${style.width}%`
  };

const clickHandler = (onSelect, onClick, event) =>
  onSelect ? () => onSelect(event) : () => onClick(event);

const CalendarEvent = ({
  label: time,
  title,
  subTitle,
  variant,
  status,
  event,
  style,
  type,
  onClick,
  onSelect,
  rtl,
  xOffset,
  view,
  ...props
}) => (
  <div
    className={calendarEventClassNames(
      variant,
      status,
      type,
      time,
      event.allDay,
      view
    )}
    style={calendarEventStyles(style, rtl, xOffset)}
    onClick={clickHandler(onSelect, onClick, event)}
    onKeyPress={clickHandler(onSelect, onClick, event)}
    role='presentation'
    {...props}
  >
    <div className='calendar__event__content'>
      {time && <time className='calendar__event__time'>{time}</time>}
      {showTitle(event.allDay, view) && (
        <span className='calendar__event__title'>{title}</span>
      )}
      {isTimeBlock(type) && (
        <span className='calendar__event__subtitle'>{subTitle}</span>
      )}
    </div>
  </div>
);

CalendarEvent.defaultProps = {
  type: 'time',
  status: 'open'
};

CalendarEvent.propTypes = {
  view: PropTypes.oneOf(['day', 'week', 'month', 'agenda']).isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'quinary',
    'senary',
    'septenary',
    'octonary',
    'nonary',
    'red',
    'green'
  ]).isRequired,
  status: PropTypes.oneOf(['confirmed', 'pending', 'cancelled', 'open']),
  style: PropTypes.object,
  event: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['time', 'date']),
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  rtl: PropTypes.bool,
  xOffset: PropTypes.string
};

export default CalendarEvent;
